


























































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import FeedbackPermissions from "@/permissions/feedback.permissions";
import { LanguageDto, FeedbackDto } from "@/server/app.dtos";

@Component
export default class DetailFeedbackSideMenuComponent extends BaseSideComponent {
  CdnUrl: string = process.env.VUE_APP_CDN_URL;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  feedbackPermissions: FeedbackPermissions = new FeedbackPermissions();
  isLoading: boolean = false;
  isValid: boolean = false;

  constructor() {
    super();
    if (this.CdnUrl.endsWith("/")) {
      this.CdnUrl = this.CdnUrl.substring(0, this.CdnUrl.length - 1);
    }
  }

  get feedback(): FeedbackDto | null {
    return this.args?.feedback || null;
  }

  canView(): boolean {
    if (this.feedback) return this.feedbackPermissions.canView(this.feedback) || false;
    return false;
  }

  canEdit(): boolean {
    if (this.feedback) return this.feedbackPermissions.canEdit(this.feedback) || false;
    return false;
  }
}
